import React, { Component } from 'react';
import parse from 'html-react-parser';

import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { fade, Modal, Typography, useTheme } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import TablePagination from '@material-ui/core/TablePagination';
import AppBar from '@material-ui/core/AppBar';
import Popover from '@material-ui/core/Popover';

import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Calendar from './index';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import CmtGridView from '../../../@coremat/CmtGridView';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { countriesEN, countriesHR } from '../../../@jumbo/constants/AppConstants';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  '@media screen and (max-width: 800px)': {
    width: '95%',
  },
  '@media screen and (min-width: 800px)': {
    width: 600,
  },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const DialogTitle = withStyles(useStyles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
}))(MuiDialogActions);

const useStyles = theme => ({
  boxTop: {
    paddingTop: theme.spacing(5),
  },
  appBar: {
    position: 'relative',
  },
  myButton: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  root: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },

  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 10,
      paddingBottom: 0,
    },
  },
  tabsList: {
    position: 'relative',
    minHeight: 60,
    '& .MuiTabs-indicator': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 60,
    padding: '5px 10px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
  },
  columnRoot: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
  table: {
    maxHeight: '50%',
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class ViewClient extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    this.handleClose = this.handleClose.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateClients = this.updateClients.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.state = {
      data: [],
      selectedId: -1,
      guestName: '',
      page: 0,
      rowsPerPage: 7,
    };
  }

  handleClickOpen() {
    //  setOpen(true);
  }

  handleChangePage(event, newPage) {
    this.setState({ page: newPage });
  }

  handleChange(name, value) {
    this.setState({ [name]: value, changed: true }, () => {
      this.updateClients();
    });
  }

  updateClients() {
    if (this.state.guestName.length < 3) return;
    const token = localStorage.getItem('token');
    const senddata = {
      Action: 'getClients',
      token: token,
      Version: 1,
      Data: {
        guestName: this.state.guestName,
      },
    };
    if (this.props.resId == -1) senddata.Action = 'getClients2';
    if (this.props.resId == -3) senddata.Action = 'getClients3';
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    //      console.log(pmsUrl);
    if (pmsUrl == '') return;
    var mode = this.props.auth.authUser.clouduser;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (res.data.Data != null) {
        this.setState({ data: res.data.Data });
      }
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleClose() {
    this.props.setState({ viewClientVisible: false });
    //  setOpen(false);
  }

  handleClick(value) {
    this.setState({ selectedId: value });
    /*const selectedIndex = this.selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);*/
  }

  handleSelect() {
    if (this.state.selectedId == -1) return;
    if (this.props.resId == '' || this.props.resId == null) return;
    if (this.props.resId == '-3') {
      var i = this.state.data.filter(
        function(item) {
          return item.id == this.state.selectedId;
        }.bind(this),
      )[0];

      const index = this.props.selGuestIndex;
      console.log(i);
      console.log(index);
      this.props.setState(prevState => {
        const guestInfos = [...prevState.guestInfo];

        guestInfos[index]['Citizenship'] = i.citizenship;
        guestInfos[index]['FirstName'] = i.firstName;
        guestInfos[index]['LastName'] = i.lastName;
        guestInfos[index]['City'] = i.city;
        guestInfos[index]['BirthDate'] = i.birthDate;

        guestInfos[index]['Country'] = i.cityCountry;
        guestInfos[index]['BirthCity'] = i.birthCity;
        guestInfos[index]['BirthCountry'] = i.birthCountry;
        guestInfos[index]['idType'] = i.idDocument;
        guestInfos[index]['idNumber'] = i.documentNum;
        guestInfos[index]['guestType'] = i.guestType;
        guestInfos[index]['guestTax'] = i.guestTax;
        guestInfos[index]['Sex'] = i.sex;

        /*if (name == 'FirstName') .FirstName = value;
      if (name == 'LastName') guestInfos[index].LastName = value;
      if (name == 'RoomId') guestInfos[index].RoomId = value;
      if (name == 'Sex') guestInfos[index].Sex = value;
      if (name == 'BirthDate') guestInfos[index].BirthDate = value;
      if (name == 'idType') guestInfos[index].idType = value;
      if (name == 'idNumber') guestInfos[index].idNumber = value;
      if (name == 'City') guestInfos[index].City = value;
      if (name == 'Country') guestInfos[index].Country = value;
      if (name == 'Citizenship') guestInfos[index].Citizenship = value;*/
        return { viewClientVisible: false, guestInfo: guestInfos };
      });

      return;
    }
    if (this.props.resId == '-2') {
      var i = this.state.data.filter(
        function(item) {
          return item.id == this.state.selectedId;
        }.bind(this),
      )[0];
      console.log(i);
      this.props.setState({
        viewClientVisible: false,
        guestName: i.first_name + ' ' + i.last_name,
        guestEmail: i.email,
        guestPhone: i.phone,
        guestId: i.id,
      });
      return;
    }
    if (this.props.resId == '-1') {
      var i = this.state.data.filter(
        function(item) {
          return item.id == this.state.selectedId;
        }.bind(this),
      )[0];

      this.props.setState({
        viewClientVisible: false,
        guestName: i.name,
        guestEmail: i.email,
        guestPhone: i.phone,
        generalName: i.name,
        generalAddress: i.address,
        generalCity: i.city,
        generalCountry: i.country,
        generalVatId: i.vatid,
      });
      return;
    }
    const token = localStorage.getItem('token');
    const senddata = {
      Action: 'setReservationClient',
      token: token,
      Version: 1,
      Data: {
        ReservationId: this.props.resId,
        ClientId: this.state.selectedId,
      },
    };
    //    console.log('pms');
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    //      console.log(pmsUrl);
    if (pmsUrl == '') return;
    var mode = this.props.auth.authUser.clouduser;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      this.props.doRefresh();
      this.props.setState({ viewClientVisible: false });
    });
    //  setOpen(false);
  }

  render() {
    const { classes } = this.props;
    var mode = this.props.auth.authUser.clouduser;
    if (this.props.auth.authUser.language == 'en') var countries = countriesEN;
    if (this.props.auth.authUser.language == 'hr') var countries = countriesHR;

    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.handleClose}
          anchorEl={this.props.anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}>
          <Box sx={style}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextField
                  id="guestName"
                  label=<IntlMessages id="bookings.guestName" />
                  value={this.state.guestName}
                  fullWidth
                  onChange={event => this.handleChange('guestName', event.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TableContainer>
                  <Table className={classes.table} aria-labelledby="tableTitle" size="dense" aria-label="enhanced table">
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>
                          {this.props.resId == -1 ? (
                            <IntlMessages id="invoice.clientName" />
                          ) : (
                            <IntlMessages id="selfcheckin.firstName" />
                          )}
                        </TableCell>
                        <TableCell>
                          {this.props.resId == -1 ? (
                            <IntlMessages id="invoice.taxId" />
                          ) : (
                            <IntlMessages id="selfcheckin.lastName" />
                          )}
                        </TableCell>
                        <TableCell>
                          <IntlMessages id="selfcheckin.country" />
                          {this.props.resId == -3 && (
                            <>
                              {', '}
                              <IntlMessages id="selfcheckin.city" />
                            </>
                          )}
                        </TableCell>
                        {this.props.resId != -1 && this.props.resId != -3 && (
                          <TableCell>
                            <IntlMessages id="res.guestEmail" />
                          </TableCell>
                        )}
                        {this.props.resId == -3 && (
                          <TableCell>
                            <IntlMessages id="selfcheckin.birthDate" />
                          </TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.data
                        .slice(
                          this.state.page * this.state.rowsPerPage,
                          this.state.page * this.state.rowsPerPage + this.state.rowsPerPage,
                        )
                        .map((row, index) => (
                          <TableRow
                            hover
                            onClick={event => this.handleClick(row.id)}
                            role="checkbox"
                            aria-checked={row.id == this.state.selectedId}
                            tabIndex={-1}
                            key={row.name}
                            selected={row.id == this.state.selectedId}>
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={row.id == this.state.selectedId}
                                inputProps={{ 'aria-labelledby': row.id }}
                              />
                            </TableCell>
                            <TableCell component="th" id={row.id} scope="row" padding="none">
                              {this.props.resId == -1 ? row.name : row.first_name}
                              {this.props.resId == -3 ? row.firstName : ''}
                            </TableCell>
                            <TableCell component="th" id={row.id} scope="row" padding="none">
                              {this.props.resId == -1 ? row.vatid : row.last_name}
                              {this.props.resId == -3 ? row.lastName : ''}
                            </TableCell>

                            <TableCell component="th" id={row.id} scope="row" padding="none">
                              {row.country}
                              {this.props.resId == -3 && (
                                <>
                                  {countries.filter(({ code }) => {
                                    return code == row.cityCountry;
                                  })[0].name +
                                    ', ' +
                                    row.city}
                                </>
                              )}
                            </TableCell>
                            {this.props.resId != -1 && (
                              <TableCell component="th" id={row.id} scope="row" padding="none">
                                {row.email}
                                {this.props.resId == -3 ? row.birthDate : ''}
                              </TableCell>
                            )}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={this.state.data.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onPageChange={(event, newPage) => this.handleChangePage(event, newPage)}
                />
              </Grid>
              <Grid item xs={6}>
                <Button variant="contained" color="primary" className={classes.myButton} onClick={() => this.handleClose()}>
                  <IntlMessages id="findClient.cancel" />
                </Button>
              </Grid>
              <Grid item xs={6}>
                {this.state.selectedId != -1 && (
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.myButton}
                    onClick={() => this.handleSelect()}>
                    <IntlMessages id="findClient.set" />
                  </Button>
                )}
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(ViewClient));
